import JsonLd from '@/components/JsonLd'
import { serviceSchema, breadcrumbSchema } from '@/lib/jsonLdSchemas'
import Navbar from '@/components/layout/Navbar'
import Footer from '@/components/layout/Footer'
import DesignHero from '@/components/sections/design/DesignHero'
import DesignServices from '@/components/sections/design/DesignServices'
import DesignPricing from '@/components/sections/design/DesignPricing'
import DesignContact from '@/components/sections/design/DesignContact'
import ServiceNav from '@/components/sections/ServiceNav'

export default function Design() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground selection:bg-accent selection:text-white">
      <JsonLd data={serviceSchema({ name: 'Brand & Identity', description: 'Distinct identity systems that scale across every touchpoint, making your brand impossible to ignore.', path: '/design' })} />
      <JsonLd data={breadcrumbSchema([{ name: 'Services', path: '/#services' }, { name: 'Design', path: '/design' }])} />
      <Navbar />
      <main>
        <DesignHero />
        <DesignServices />
        <DesignPricing />
        <DesignContact />
        <ServiceNav />
      </main>
      <Footer />
    </div>
  )
}
